import { render, staticRenderFns } from "./extend_form.vue?vue&type=template&id=645b96b2&scoped=true"
import script from "./extend_form.vue?vue&type=script&lang=js"
export * from "./extend_form.vue?vue&type=script&lang=js"
import style0 from "./extend_form.vue?vue&type=style&index=0&id=645b96b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b96b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645b96b2')) {
      api.createRecord('645b96b2', component.options)
    } else {
      api.reload('645b96b2', component.options)
    }
    module.hot.accept("./extend_form.vue?vue&type=template&id=645b96b2&scoped=true", function () {
      api.rerender('645b96b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_related_information_report/visitDetail/components/extend_form.vue"
export default component.exports